import API from "../config/api";

export function sendMessage(message, status, subject) {
  API.post(`emails/bulkEmails?status=${status}`, {
    paragraph: message,
    subject,
  });
}
